<template>
  <div class="col-md-6 col-lg-4">
    <div class="price-card d-flex flex-column align-items-center">
      <h2>{{ card.title }}</h2>
      <h1 class="price">{{ card.artist }}</h1>
      <h3 class="month">{{ card.artist }}</h3>
      <div class="features">
        <p v-for="(feature, i) in card.features" :key="i">{{ feature }}</p>
      </div>
      <b-button
        variant="primary btn-round-fill"
        :class="{ activee: card.upgrade }"
        >{{ card.upgrade ? "Upgrade" : "Play" }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["card"],
  data() {
    return {
      primary: "primary",
      btnRoundFill: "btn-round-fill"
    };
  }
};
</script>

<style lang="scss" scoped>
.price-card {
  font-family: "Nunito", sans-serif;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  background: #ffffff;
  border-radius: 8px;

  width: 100%;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
    // min-width: 350px;
    // min-width: 100%;
    max-width: 350px;
  }
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    margin-top: 32px;
    margin-bottom: 14px;

    color: #474d52;
  }
  .price {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    display: flex;
    align-items: center;
    text-align: center;

    margin-bottom: 18px;
    color: #474d52;
  }
  .month {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
  }
  .features {
    margin-top: 32px;
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;

      display: flex;
      align-items: center;
      letter-spacing: 0.03em;

      /* Secondary */

      color: #8d99a0;
      margin-bottom: 16px;
    }
  }

  .btn-round-fill {
    max-width: 205px !important;
    width: 100%;
    height: 48px !important;
    font-style: normal;
    font-weight: normal !important;
    font-size: 16px;
    font-family: "Nunito", sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
    border: none;
    margin-bottom: 24px;
    margin-top: 32px !important;
    &.activee {
      background: rgba(85, 126, 251, 0.1) !important;
      color: var(--theme-color);
    }
  }
}
</style>
